import React, { type FC } from "react";
import { RegisterModalDatameshIds } from "@components/Register/RegistrationBox/config/datameshIds";
import { withPrefix } from "@tracking/tracking";
import { useTrackElement, useTranslation } from "@edreamsodigeo/frontend-core";
import { Body } from "@edreamsodigeo/prisma-design-system";

import type { PasswordErrorBody } from "./contract";

export const PasswordErrorsMessageBody: FC<PasswordErrorBody> = ({
  key,
  error,
  trackingPrefix,
}) => {
  const { t } = useTranslation();
  const mappedErrorTrackingLabel = {
    "auth.form.password.error.format":
      RegisterModalDatameshIds.onError.passwordFormat,
    "auth.error.server.connection":
      RegisterModalDatameshIds.onError.connectionError,
    "auth.error.server.remote": RegisterModalDatameshIds.onError.genericError,
  };

  const trackingRefPasswordErrorDisplay = useTrackElement(
    ["display"],
    withPrefix(mappedErrorTrackingLabel[error], trackingPrefix),
  );

  return (
    <Body key={key} type="xSmall" ref={trackingRefPasswordErrorDisplay}>
      {t(error)}
    </Body>
  );
};
